module.exports = __webpack_public_path__ + "img/phone.6ef5985c.svg";